import {h, Fragment} from "preact"
import Product from './Product'
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks'

export default () => {
    const { response: { products }, loading } = useAppState()
    const isSaleCollection = (products?.categoryId === "346037894");
    const isHempDivision = (products?.categoryId === "156070510663");

    useEffect(() => {
        if(!window.StampedFn?.reloadUGC) return;
        window.StampedFn.reloadUGC();

        // nostojs(api => api.createRecommendationRequest()
        //     .setElements(['ns-ocp'])
        //     .load()
        // )
    }, [])

    return (
        <product-list class="product-facet__product-list product-list" style={loading ? 'opacity: 0.3;' : ''}>
            {/* <div class="nosto_element" id="ns-ocp"></div> */}
            <div class="product-list__inner">
                {products.hits.map((hit, index) => (
                    <Product 
                        product={hit}
                        isSaleCollection={isSaleCollection}
                        isHempDivision={isHempDivision}
                        key={hit.productId || index}
                    />
                ))}
            </div>
        </product-list>
    )
}
